import React from 'react'
import { motion } from 'framer-motion'
import './Skills.css'

const Skills = () => {
  const skillCategories = [
    {
      title: 'Data Analysis',
      skills: ['SQL', 'Excel', 'Data Cleaning', 'Statistical Analysis'],
      color: '#2563eb',
    },
    {
      title: 'Visualization',
      skills: ['Tableau', 'Power BI', 'Data Storytelling'],
      color: '#06b6d4',
    },
    {
      title: 'Technical',
      skills: ['SQL', 'Excel VBA', 'Git & Version Control'],
      color: '#0891b2',
    },
    {
      title: 'Business',
      skills: [
        'Strategic Planning',
        'Presentations',
        'Problem Solving',
        'Project Management',
        'Communication',
      ],
      color: '#1e40af',
    },
    {
      title: 'SAP & Systems',
      skills: [
        'SAP S/4HANA',
        'MM (Materials Management)',
        'Logistics Execution',
        'Inventory Management',
        'STO',
        'eClinicalWorks (eCW)',
      ],
      color: '#7c3aed',
    },
    {
      title: 'Business Analysis',
      skills: [
        'Requirements Gathering',
        'Process Improvement',
        'Workflow Analysis',
        'Root Cause Analysis',
        'Technical Documentation',
        'Compliance & QA',
      ],
      color: '#0d9488',
    },
    {
      title: 'Operations & Reporting',
      skills: [
        'Pivot Tables',
        'VLOOKUP',
        'Dashboard Support',
        'Trend Analysis',
        'Data Validation',
        'Audit Readiness',
      ],
      color: '#b45309',
    },
  ]

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  }

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 },
    },
  }

  return (
    <section id="skills" className="skills section dark">
      <div className="container">
        <h2 className="section-title">Skills & Expertise</h2>

        <motion.div
          className="skills-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {skillCategories.map((category, index) => (
            <motion.div
              key={index}
              className="skill-card"
              variants={cardVariants}
              whileHover={{ y: -10 }}
            >
              <div
                className="skill-card-header"
                style={{ borderTopColor: category.color }}
              >
                <h3>{category.title}</h3>
              </div>
              <div className="skill-card-body">
                {category.skills.map((skill, skillIndex) => (
                  <motion.span
                    key={skillIndex}
                    className="skill-tag"
                    style={{ borderColor: category.color }}
                    whileHover={{ scale: 1.05 }}
                  >
                    {skill}
                  </motion.span>
                ))}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  )
}

export default Skills
